import React, { ReactElement } from 'react';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import {
  DEFAULT_GUTTER,
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
  overflowXScroll,
  overflowYScroll,
  marginAuto,
  flexOne,
} from '@/styles';
import { useLocationController } from '@/controllers';

import Survey from '../composed/survey';

import GlobalInfo from './global-info';

const pageStyles = css`
  box-sizing: border-box;
  ${marginAuto};
  padding: ${DEFAULT_GUTTER * 2}px;
  /* FIXME: This design is not ideal, the more events we get, we cannot keep extending the padding. Needs design. */
  /* NOTE: This is so elements that appear only on hover on a short page has room to move before suddenly reflowing the height. */
  padding-bottom: 70vh;
  ${overflowXScroll}
  ${overflowYScroll}
  ${flexOne}

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    max-width: 90%;
    padding: ${DEFAULT_GUTTER * 2}px ${DEFAULT_GUTTER}px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    zoom: 0.85;
    -moz-transform: scale(0.85);
    padding: ${DEFAULT_GUTTER}px;
    max-width: none;
  }
`;

export const PAGE_ADVANCE_VERTICAL_PADDING = DEFAULT_GUTTER * 1.5;
const pageAdvancedStyles = css`
  padding: ${PAGE_ADVANCE_VERTICAL_PADDING}px ${DEFAULT_GUTTER * 2}px;
  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    max-width: none;
    padding: ${PAGE_ADVANCE_VERTICAL_PADDING}px ${DEFAULT_GUTTER * 2}px;
  }
`;

const pageDashboardStyles = css`
  background: ${token('color.background.input.hovered', '#F7F8F9')}};
`;

// Need this for applying sticky header elements
const pageNoPaddingTopStyles = css`
  padding-top: 0;
`;

type PageProps = {
  children: ReactElement;
};

/**
 * Governs gutters, padding for page layout
 */
const Page: React.FC<PageProps> = ({ children }) => {
  // TODO: Optimise breakpoint across the entire app. e.g homepage shouldn't
  // have weird side gap on large resolution, e.g 1400px
  const {
    isSearchPage,
    isHomepage,
    isDashboard,
    isSLOGroupPage,
    isSLOPage,
  } = useLocationController();

  return (
    <div
      css={[
        pageStyles,
        isSearchPage || isHomepage || isDashboard || isSLOGroupPage ? pageAdvancedStyles : '',
        isHomepage || isDashboard ? pageDashboardStyles : '',
        isSLOGroupPage ? pageNoPaddingTopStyles : '',
      ]}
    >
      {children}
      {/* TODO: implement Dynamic Config in slo-ui */}
      {false && <Survey />}
      {isSLOPage && <GlobalInfo />}
    </div>
  );
};

export default Page;
